import React from 'react'

export const SubStr = props => {
    const { children, from = 0, to = 20 } = props || {}

    if (children && children?.length > to) {
        const FormattedString = children?.substr(from, to)
        return <>{FormattedString}...</>
    }

    return <>{children}</>
}
